import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'

import { forwardRef } from 'react'

import { cn } from '@/lib/utils'
import { raisedShadow, sunkenShadow, useDesk95Theme } from './theme'

export interface BezelProps extends HTMLAttributes<HTMLDivElement> {
    variant?: 'raised' | 'sunken'
    thin?: boolean
    face?: boolean
    children?: ReactNode
    style?: CSSProperties
}

/**
 * The four-corner chrome primitive. Every button, window border, sunken text
 * box and taskbar slot goes through it.
 */
export const Bezel = forwardRef<HTMLDivElement, BezelProps>(function Bezel(
    { variant = 'raised', thin = false, face = true, className, style, children, ...rest },
    ref
) {
    const palette = useDesk95Theme()
    const shadow = variant === 'raised' ? raisedShadow(palette, thin) : sunkenShadow(palette, thin)

    return (
        <div
            ref={ref}
            className={cn('relative', className)}
            style={{
                boxShadow: shadow,
                backgroundColor: face ? palette.face : undefined,
                color: palette.text,
                ...style
            }}
            {...rest}
        >
            {children}
        </div>
    )
})
